import React, { useState } from 'react';
import { Card, Col, Row } from 'antd';
import { fetchData } from '../../service/dataServices';
import { useTranslation } from 'react-i18next';

function CountryCard(props) {
  const [data, setData] = useState([]);
  const response = fetchData('/api/dashboard/group-country', data => setData(data));
  
  const { t, i18n } = useTranslation();

  const getCountryName = (countryData) => {
    if (!countryData) return '';

    let parsedData = countryData;

    if (typeof countryData === 'string' && countryData.trim().startsWith('{')) {
      try {
        parsedData = JSON.parse(countryData);
      } catch (e) {
        return t(`countries.${countryData.trim()}`, countryData);
      }
    }

    let lookupKey = null;
    if (typeof parsedData === 'object' && parsedData !== null) {
      lookupKey = (parsedData['en'] || parsedData['ar'] || Object.values(parsedData)[0] || '').trim();
    } else if (typeof parsedData === 'string') {
      lookupKey = parsedData.trim();
    }

    if (!lookupKey) return '';

    const variants = [
      lookupKey,                                                    
      lookupKey.toUpperCase(),                                      
      lookupKey.charAt(0).toUpperCase() + lookupKey.slice(1).toLowerCase(), 
    ];

    for (const variant of variants) {
      const translated = t(`countries.${variant}`, '');
      if (translated) return translated;
    }

    if (typeof parsedData === 'object') {
      return parsedData[i18n.language] || lookupKey;
    }
    return lookupKey;
  };

  return (
    <Card
      loading={response.isLoading}
      title={t("dashboard.countryCard_title")}
      styles={{
        body: { color: '#6c757d', height: '567px', overflow: 'scroll' },
        header: { color: '#00000073', fontSize: '14px' }
      }}
    >
      {data.map(row => (
        <Row key={`${JSON.stringify(row.x)}-${row.y}`}>
          <Col span={21}>
            {getCountryName(row.x)}
          </Col>
          <Col span={3}>
            {row.y}
          </Col>
        </Row>
      ))}
    </Card>
  );
}

export default CountryCard;